import lodash from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from '../../common/link/Link';
import {PageTitle} from '../../common/pageTitle/PageTitle';

import videoPagesHoc from '../../hoc/videoPagesHoc';
import {videoPagesRoute} from '../../routePaths';

import PropTypes from 'prop-types';
import VideoSections from '../../common/videoSection/videoSection';
import {Helmet} from 'react-helmet';
import './videoPages.scss';
import updated_boat_animation from "../home/assets/MMR-Website-Boat.gif";

/**
 * The StatesPage component.
 *
 * @constructor
 */
export class VideoPage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);

    this.state = {
      'height':'',
      'width':'',
      'applyMarginLeft':''
    }
    this.updateDimensions = this.updateDimensions.bind(this);
    this.logDimensions = this.logDimensions.bind(this);
  }

  /**
   * Triggers before the component is added to the page.
   */
  componentWillMount() {
    // var locationParams = this.props.location.pathname;
    // locationParams = locationParams.split('/');

    // var pageSlug = locationParams[1];
    // console.log('the page slug is ', pageSlug);
    // console.log('the video page component has been called!');
    this.props.videoPagesHoc.getVideoData(this.props.match.params.companyName)

  }

  componentDidMount() {
    // console.log('weeee')
    // console.log(this.scrollTarget);
    // const scrollTarget = ReactDOM.findDOMNode(this.scrollTarget);
    // console.log(scrollTarget.top);
    // window.scrollTo(0, scrollTarget.offsetTop);
  }


  logDimensions(){
    console.log('the height is ',this.state.height);
    console.log('the width is ',this.state.width);
  }

  updateDimensions(){
    let offsetConst = 220
    let applyMarginLeft= (window.innerWidth - 3000)+offsetConst

    this.setState({
      height: window.innerHeight,
      width: window.innerWidth,
      applyMarginLeft
    },()=>{

    });
  }


  createSponsorPageHeader = (pageType , videoPageLogo , videoPageBlurb,topLogoLink) =>{
    switch(pageType) {
      case 'conglomorate-sponsor-page':
        return  <div className="sponsorPageHeader">
             <div className="row">
               <div className="col-md-4">
               </div>

               <div className="col-md-4 largeLogoImg">
                 <a href={topLogoLink ? topLogoLink : '#'} target="_blank"> <img src={videoPageLogo}   /> </a>
                 <p>{videoPageBlurb}</p>
               </div>

               <div className="col-md-4">
               </div>
             </div>
        </div>

      case 'regular-sponsor-page':
        return <div className="sponsorPageHeader">

          <div className="row">
            <div className="col-md-4">
            </div>

            <div className="col-md-4 largeLogoImg">
              <a href={topLogoLink ? topLogoLink : '#'} target="_blank">   <img src={videoPageLogo}/> </a>
              <p>{videoPageBlurb}</p>
            </div>

            <div className="col-md-4">
            </div>
          </div>

        </div>

    }

  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const isLoading = this.props.videoPagesHoc.isLoading;
    const videoPageData = this.props.videoPagesHoc.videoPageData;
    const videos = this.props.videoPagesHoc.videos;
    let showAnimation = false;
    console.log()
    console.log('the location is ',window.location)

    if(window.location.pathname=='/psa'){
      window.addEventListener("resize", this.updateDimensions);
      showAnimation = true;
    }


    let videoPageTitle;
    let videoPageType;
    let videoPageBlurb;
    let videoPageLogo;
    let featuredVideo;
    let leftBottomLogo;
    let rightBottomLogo;
    let leftBottomLogoLink;
    let rightBottomLogoLink;
    let largeBottomLogoLink;
    let largeTopLogoLink;
    let hasFeaturedVideo = false;
    let applyMarginLeft = this.state.applyMarginLeft;


    if (videoPageData && videoPageData.length>0) {

      videoPageTitle = videoPageData[0].pageTitle;
      videoPageType = videoPageData[0].pageType;
      videoPageBlurb = videoPageData[0].pageBlurb;
      videoPageLogo = videoPageData[0].pageLogoUrl;
      leftBottomLogo = videoPageData[0].leftBottomLogo;
      rightBottomLogo = videoPageData[0].rightBottomLogo;
      leftBottomLogoLink = videoPageData[0].leftBottomLogoLink;
      rightBottomLogoLink = videoPageData[0].rightBottomLogoLink;
      largeBottomLogoLink = videoPageData[0].largeBottomLogoLink;
      largeTopLogoLink = videoPageData[0].largeTopLogoLink;
    }




  else if (videoPageData && videoPageData.length===0){
       this.props.history.push('/');
    }

    var readyToShow = {
      visibility:'hidden'
    };
    console.log('is loading is ', isLoading);
    console.log('video page data is ', videoPageData);



    console.log('the videos are ', videos);



    console.log('the featured video is ',featuredVideo);

    if (videos){

      console.log('this condition is met');
      console.log('-----------------');
      console.log(videos);
      console.log(videos.length);

      for(var i=0; i < videos.length; i++){

        var video = videos[i];
        if (video.isFeatured==1){
          featuredVideo = video;
          hasFeaturedVideo = true;
        }
      }

      readyToShow = {
        visibility:'visible'
      }
    }



    return (
      <div className="videoPageContent">

        { videoPageType == 'nei-base' && <h1 id="mainTitle">{videoPageTitle}</h1>}

        {videoPageType =='nei-base' && <Helmet><title>Meet the Experts - NEI</title><meta name = "description" content ="You may be surprised to learn how not contacting 811 before digging can negatively affect your city's public services budget." /></Helmet>}

        {this.createSponsorPageHeader(videoPageType, videoPageLogo, videoPageBlurb, largeTopLogoLink)}

        { hasFeaturedVideo && <div className='featuredVideoSection'> <div className="featuredVideo row desktopView">
        <div className="banner">
        </div>
           <div className="container featuredArea">
              <div className="row">
              <div className=" col-sm-1 .d-sm-none .d-md-block"></div>

              <div className="col-12 col-md-5">
                  <div className="video">
                    <iframe  ref="mainVideo" src={featuredVideo ? featuredVideo.url : ''}  frameBorder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen="true"></iframe>
                  </div>
                  { featuredVideo.relatedContentLink && <div className="relatedContentFeatured">
                   <h6 className="relatedContentHeadline">RELATED CONTENT</h6>
                   <a href={featuredVideo.relatedContentLink}>{featuredVideo.linkName}</a>
                 </div>}
              </div>

              <div className=" col-12 col-md-5 featuredDescriptionCol">
              <h6 className="featuredVideoHeader">Featured Video</h6>
                  <div>
                    <h2 className="featuredTitle">{featuredVideo ? featuredVideo.title : ''}</h2>
                  </div>
                  <p className="featuredDescription">
                    {featuredVideo ? featuredVideo.description : ''}
                  </p>
              </div>

              <div className="col-sm-1 .d-sm-none .d-md-block"></div>

              </div>
           </div>
        </div>

        <div className="featuredVideoMobile row mobileView">

          <div className="featuredVideoMobile contentContainer col-12 col-md-6">
             <div className="video">
                 <iframe  ref="mainVideo" src={featuredVideo ? featuredVideo.url : ''}  frameBorder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen="true"></iframe>
              </div>

              { featuredVideo.relatedContentLink && <div className="relatedContentFeatured">
                   <h6 className="relatedContentHeadline">RELATED CONTENT</h6>
                   <a href={featuredVideo.relatedContentLink}>{featuredVideo.linkName}</a>
                 </div>}
          </div>

          <div className="featuredTextMobile contentContainer col-12 col-md-6">
              <div>
                <h2 className="featuredTitle">{featuredVideo ? featuredVideo.title : ''}</h2>
              </div>
              <p className="featuredDescription">
                    {featuredVideo ? featuredVideo.description : ''}
              </p>
          </div>
        </div> </div> }

        {videos &&
        <VideoSections videoData={videos}/>
        }

        {
          videoPageType == 'conglomorate-sponsor-page' &&


          <div className="subsidiariesListContainer">


            <div className="row bottomContentContainer">

              <div className="col-lg-4 col-md-3 col-12 hidden-mobile">
                {leftBottomLogo && <a href={leftBottomLogoLink ? leftBottomLogoLink : '#'} target="_blank"><img src={`https://directus.safeexcavator.com/${leftBottomLogo.url}`}  className="img-v-centered" /></a> }
              </div>

              <div className="col-lg-4 largeLogoImg col-md-6 col-12" >
                <a href={largeBottomLogoLink ? largeBottomLogoLink : '#' } target="_blank"> <img src={videoPageLogo}  id="center-logo"/> </a>
                <div dangerouslySetInnerHTML={{__html: videoPageData[0].subsidiariesList }}>
                </div>
              </div>


              <div className="col-lg-4 col-md-3 col-12 visible-mobile">
                {leftBottomLogo && <a href={leftBottomLogoLink ? leftBottomLogoLink : '#'} target="_blank"><img src={`https://directus.safeexcavator.com/${leftBottomLogo.url}`}  className="img-v-centered" /></a> }
              </div>

              <div className="col-lg-4 col-md-3 col-12">
                {rightBottomLogo && <a href={rightBottomLogoLink ? rightBottomLogoLink : '#'}  target="_blank"> <img src={`https://directus.safeexcavator.com/${rightBottomLogo.url}`} className="img-v-centered" /></a> }
              </div>

            </div>


          </div>
        }

        {showAnimation && <div className="sewage-river-container" style={{marginLeft: applyMarginLeft +'px'}} >
          <a href="#" onClick={ e => { e.preventDefault(); this.props.history.push('/psa');} }>
            <img src={updated_boat_animation} align='right' onLoad = {this.updateDimensions.bind(this)}  />
          </a>
        </div>}


      </div>
    );
  }
}

videoPagesHoc.propTypes = {
  videoPagesHoc: PropTypes.shape({
    getVideoData: PropTypes.func,
    isLoading: PropTypes.bool,
    videoPageData: PropTypes.array,
    videos: PropTypes.array,
    error: PropTypes.object,
  }),
};

export default videoPagesHoc(
  VideoPage
);



// WEBPACK FOOTER //
// ./src/components/pages/videoPages/videoPages.js